<template>
    <div class="modal-control-buttons">
        <btn l="Удалить" t='d' s='m' i='trash' @press="remove" pull='left' v-if="showRemove"></btn>
        <btn l="Сохранить" t='s' s='m' i='save' :disabled="disabledSave" @press="saveForm" pull='right'></btn>
        <btn l="Закрыть" t='df' s='m' i='times' @press="cancel" pull='right'></btn>
    </div>
</template>
<script>
export default {
    name: 'modal-control-buttons',
    props: {
        showRemove: { type: Boolean, default: true },
        formName: {type:String},
        disabledSave: { type: Boolean, default: false }
    },
    methods: {
        cancel() { this.closeModal(this.$parent.name); },
        saveForm() {
            let {formName} = this;
            //this.closeModal(this.$parent.name);
            _i.bus.$emit('save-form',formName);
            this.$emit('save');
        },
        remove() {
            if (confirm('Подтвердить удаление?')) {
                this.$emit('remove');
                this.closeModal(this.$parent.name);
            }
        }
    },
    data() {
        return {

        }
    }
}
</script>
<style lang="css" scoped>
</style>